export const basketConfigUs = {
    fundCard: {
        show: ['ticker', 'fundName', 'active', 'assetClass'],
    },
    dataPoints: {
        productId: 'fundHeader.custom-metadata.productId',
        ticker: 'fundHeader.fundTicker.ticker',
        fundName: 'fundHeader.fundName.fundName',
        active: 'fundHeader.custom-metadata.investmentStyle',
        assetClass: 'fundHeader.custom-metadata.assetClass',
        legalStructure: 'fundHeader.custom-metadata.legalStructure',
        productType: 'fundHeader.custom-metadata.productType',
    },
    deniedProductTypes: ['BLK_MUTUAL_FUND_DATA'],
};
export const basketConfigUk = {
    fundCard: {
        show: ['ticker', 'fundName', 'shareClass', 'active', 'assetClass'],
    },
    dataPoints: {
        productId: 'fundHeader.custom-metadata.productId',
        ticker: 'fundHeader.fundTicker.ticker',
        fundName: 'fundHeader.fundName.fundName',
        active: 'fundHeader.custom-metadata.investmentStyle',
        assetClass: 'fundHeader.custom-metadata.assetClass',
        legalStructure: 'fundHeader.custom-metadata.legalStructure',
        productType: 'fundHeader.custom-metadata.productType',
        shareClass: [
            'fundHeader.custom-metadata.seriesCurrencyCode',
            'fundHeader.custom-metadata.investorClassCode',
            'keyFundFacts.useOfProfitsCode',
        ],
        sfdr: 'keyFundFacts.sfdr',
    },
    deniedProductTypes: [],
};
export const basketConfigDe = {
    fundCard: {
        show: ['ticker', 'fundName', 'shareClass', 'active', 'assetClass'],
    },
    dataPoints: {
        productId: 'fundHeader.custom-metadata.productId',
        ticker: 'fundHeader.fundTicker.ticker',
        fundName: 'fundHeader.fundName.fundName',
        active: 'fundHeader.custom-metadata.investmentStyle',
        assetClass: 'fundHeader.custom-metadata.assetClass',
        legalStructure: 'fundHeader.custom-metadata.legalStructure',
        productType: 'fundHeader.custom-metadata.productType',
        shareClass: [
            'fundHeader.custom-metadata.seriesCurrencyCode',
            'fundHeader.custom-metadata.investorClassCode',
            'keyFundFacts.useOfProfitsCode',
        ],
        sfdr: 'keyFundFacts.sfdr',
    },
    deniedProductTypes: [],
};
export const basketConfigCh = {
    fundCard: {
        show: ['ticker', 'fundName', 'shareClass', 'active', 'assetClass'],
    },
    dataPoints: {
        productId: 'fundHeader.custom-metadata.productId',
        ticker: 'fundHeader.fundTicker.ticker',
        fundName: 'fundHeader.fundName.fundName',
        active: 'fundHeader.custom-metadata.investmentStyle',
        assetClass: 'fundHeader.custom-metadata.assetClass',
        legalStructure: 'fundHeader.custom-metadata.legalStructure',
        productType: 'fundHeader.custom-metadata.productType',
        shareClass: [
            'fundHeader.custom-metadata.seriesCurrencyCode',
            'fundHeader.custom-metadata.investorClassCode',
            'keyFundFacts.useOfProfitsCode',
        ],
    },
    deniedProductTypes: [],
};
